// Documents
export const ADD_DOCUMENT = 'FETCH'
export const UPLOAD = 'UPLOAD'
export const CLEAR_DOCUMENTS = 'CLEAR_DOCUMENTS'



// WEBPACK FOOTER //
// ./src/common/store/Documents/types.js